import flatpickr from "https://esm.sh/flatpickr@4.6.13";
import "https://esm.sh/flatpickr@4.6.13/dist/l10n/ja.js";

/*
 * 予約不可日・時間の設定
 *  - テーマ設定「予約カレンダー」(全コース共通)
 *  - 商品メタフィールド custom.blocked_slots (コースごと)
 * 書式(1行に1件):
 *   2026-12-31                 … 終日予約不可
 *   2026-12-29~2027-01-03      … 期間すべて予約不可
 *   2026-11-10 12:00,17:30     … その日の指定時間だけ非表示
 *   # で始まる行はメモ(無視)
 */
const toHalf = (s) =>
  s.replace(/[０-９：～〜／－]/g, (c) =>
    ({ '：': ':', '～': '~', '〜': '~', '／': '-', '－': '-' }[c] ||
      String.fromCharCode(c.charCodeAt(0) - 0xfee0))
  );

const normDate = (s) => {
  const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!m) return null;
  return `${m[1]}-${m[2].padStart(2, '0')}-${m[3].padStart(2, '0')}`;
};

const normTime = (s) => {
  const m = String(s).trim().match(/^(\d{1,2}):(\d{2})/);
  return m ? `${Number(m[1])}:${m[2]}` : String(s).trim();
};

const fmtDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const parseBlocked = (raw) => {
  const days = new Set();
  const ranges = [];
  const slots = {};
  (raw || '').split(/\r?\n/).forEach((line) => {
    line = toHalf(line).replace(/\//g, '-').trim();
    if (!line || line.startsWith('#')) return;
    let m = line.match(/^(\S+)\s*~\s*(\S+)$/);
    if (m) {
      const from = normDate(m[1]);
      const to = normDate(m[2]);
      if (from && to) ranges.push([from, to]);
      return;
    }
    m = line.match(/^(\S+)(?:\s+(.+))?$/);
    const d = m && normDate(m[1]);
    if (!d) return;
    if (!m[2]) {
      days.add(d);
      return;
    }
    m[2].split(/[,、\s]+/).forEach((t) => {
      if (!t) return;
      (slots[d] = slots[d] || new Set()).add(normTime(t));
    });
  });
  return { days, ranges, slots };
};

document.addEventListener('DOMContentLoaded', () => {
  const dateInput = document.getElementById('select_date');
  if (!dateInput) return;

  const timeSelect = document.getElementById('select_time');
  const addButton = document.querySelector('.product-form__submit');
  const blocked = parseBlocked(dateInput.dataset.blocked);

  // 時間の選択肢(元の一覧)を保存
  const allTimes = timeSelect
    ? Array.from(timeSelect.options).map((o) => ({ value: o.value, text: o.text }))
    : [];
  const realTimes = allTimes.filter((o) => o.value !== '');

  const availableTimes = (dateStr) => {
    const s = blocked.slots[dateStr];
    return s ? realTimes.filter((o) => !s.has(normTime(o.value))) : realTimes;
  };

  const isDayBlocked = (dateStr) => {
    if (blocked.days.has(dateStr)) return true;
    if (blocked.ranges.some(([a, b]) => dateStr >= a && dateStr <= b)) return true;
    // 時間がすべて不可の日は終日不可扱い
    if (realTimes.length && blocked.slots[dateStr] && availableTimes(dateStr).length === 0) return true;
    return false;
  };

  const updateButtonState = () => {
    if (!addButton || !timeSelect) return;
    addButton.disabled = !(dateInput.value !== '' && timeSelect.value !== '');
  };

  const rebuildTimes = () => {
    if (!timeSelect) return;
    const current = timeSelect.value;
    const list = dateInput.value ? availableTimes(dateInput.value) : realTimes;
    timeSelect.innerHTML = '';
    allTimes
      .filter((o) => o.value === '' || list.includes(o))
      .forEach((o) => timeSelect.add(new Option(o.text, o.value)));
    timeSelect.value = list.some((o) => o.value === current) ? current : '';
    updateButtonState();
  };

  const isJa = (document.documentElement.lang || '').startsWith('ja');
  const minDays = Number(dateInput.dataset.minDays || 7);
  const maxDays = Number(dateInput.dataset.maxDays || 30);

  flatpickr(dateInput, {
    locale: isJa ? 'ja' : 'default',
    minDate: new Date().fp_incr(minDays),
    maxDate: new Date().fp_incr(maxDays),
    disable: [(date) => isDayBlocked(fmtDate(date))],
  });

  dateInput.addEventListener('change', rebuildTimes);
  if (timeSelect) timeSelect.addEventListener('change', updateButtonState);
  updateButtonState();
});
